import React, {Dispatch, FC, SetStateAction, useCallback, useMemo} from 'react';
import './HtmlEditor.scss';
import {useAuth} from '../../providers/AuthProvider';
import {ToastSettings} from '../ToastSettings';
import {CampaignsService} from '../../services/Campaigns/CampaignsService';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import {useRichEditor} from '../../hooks/useRichEditor';

interface HtmlEditorProps {
    html?: string;
    setHtml: Dispatch<SetStateAction<string>>;
    fieldName?: string;
    fieldError?: any;
    widthPercent?: number;
    height?: number;
    maxCharacter: number;
    minCharacter: number;
}

const HtmlEditor: FC<HtmlEditorProps> = ({
                                             fieldError,
                                             setHtml,
                                             minCharacter,
                                             maxCharacter,
                                             html,
                                             height = 450,
                                             widthPercent = 100,
                                             fieldName = 'Descrição'
                                         }) => {
    const {onInvalid} = useAuth();

    const campaignsService = useMemo(() => new CampaignsService(), []);

    const uploadHandler = useCallback(async (file: File) => {
        try {
            const [_Response, _Message, _Code, _Errors] = await campaignsService.saveFileEmail(file);

            if (!!_Message) {
                ToastSettings(_Message, "bottom-center", "error", () => {
                }, _Errors);
                return undefined;
            }

            return _Response?.data?.url;
        } catch {
            return undefined;
        }
    }, [campaignsService]);

    const {quillRef} = useRichEditor({
        defaultHtml: html,
        uploadHandler,
        onChange: (value) => setHtml(value)
    });

    return (
        <div className="HtmlEditor" data-testid="HtmlEditor">
            <div className={`${onInvalid(fieldError)}`}
                 style={{width: `${widthPercent}%`, height: height, maxHeight: height}}>
                <div ref={quillRef}/>
                <ErrorMessage name={fieldName} type={fieldError?.type} min={minCharacter} max={maxCharacter}/>
            </div>
        </div>
    );
};

export default HtmlEditor;